import React, { useContext, useEffect, useState, useCallback } from "react";
import { NoteState } from "../../context/notes/NoteState";
import UserServices from "../../UserServices/UserServices";
import Swal from "sweetalert2";
import moment from "moment";
import MenuButton from "../MenuButton/MenuButton";

// â”€â”€â”€ Status helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const statusBadge = (s) => {
  const map = {
    Delivered: "badge bg-success",
    "No Show": "badge bg-warning text-dark",
    Cancel: "badge bg-secondary",
    Canceled: "badge bg-secondary",
  };
  return <span className={map[s] || "badge bg-light text-dark"}>{s}</span>;
};

// â”€â”€â”€ Avatar fallback â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const AVATAR_FALLBACK =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Ccircle cx='40' cy='40' r='40' fill='%23e9ecef'/%3E%3Ccircle cx='40' cy='28' r='14' fill='%23adb5bd'/%3E%3Cellipse cx='40' cy='64' rx='22' ry='14' fill='%23adb5bd'/%3E%3C/svg%3E";

// â”€â”€â”€ Time slots 06:00â†’22:00 (1-hour each = 16 slots) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const TIME_SLOTS = Array.from({ length: 16 }, (_, i) => {
  const h = i + 6;
  return `${String(h).padStart(2, "0")}:00-${String(h + 1).padStart(2, "0")}:00`;
});

// â”€â”€â”€ Small commission card â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const CommissionCard = ({ label, value, cls }) => (
  <div className="col-6 col-md-3 mb-3">
    <div className={`card border-0 shadow-sm h-100 ${cls || ""}`}>
      <div className="card-body text-center p-3">
        <p className="text-muted small mb-1">{label}</p>
        <h4 className="fw-bold mb-0">{value}</h4>
      </div>
    </div>
  </div>
);

// â”€â”€â”€ Slot Picker Modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SlotPickerModal = ({ client, sessionDate, onClose, onConfirm, saving }) => {
  const today = moment().format("YYYY-MM-DD");
  const [date, setDate] = useState(sessionDate || today);
  const [selectedSlot, setSelectedSlot] = useState(null);

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)" }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 500 }}>
        <div className="modal-content border-0 shadow" style={{ borderRadius: 16 }}>
          <div className="modal-header border-0" style={{ background: "linear-gradient(135deg,#198754,#20c997)", borderRadius: "16px 16px 0 0" }}>
            <div className="d-flex align-items-center gap-3">
              <img src={client.client_image || AVATAR_FALLBACK} alt={client.client_name}
                style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(255,255,255,0.7)" }} />
              <div>
                <h5 className="modal-title fw-bold text-white mb-0">Mark as Present</h5>
                <small className="text-white opacity-75">{client.client_name} Â· {client.package_name}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body p-4">
            <div className="mb-3">
              <label className="form-label fw-semibold small">Session Date *</label>
              <input type="date" className="form-control" value={date} max={today}
                onChange={(e) => setDate(e.target.value)} />
              <small className="text-muted">Attendance is verified for this date.</small>
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold small">
                Select Time Slot *
              </label>
              <div className="row g-2">
                {TIME_SLOTS.map((slot) => {
                  const selected = selectedSlot === slot;
                  return (
                    <div key={slot} className="col-6 col-sm-4">
                      <button type="button"
                        onClick={() => setSelectedSlot(slot)}
                        className={`btn btn-sm w-100 py-2 ${selected ? "btn-success" : "btn-outline-success"}`}
                        style={{ fontSize: 12 }}>
                        {slot}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
            {selectedSlot && (
              <div className="alert alert-success py-2 mb-0">
                <i className="fa fa-check-circle me-2" />
                <strong>{selectedSlot}</strong> selected for <strong>{client.client_name}</strong>
              </div>
            )}
          </div>
          <div className="modal-footer border-0 pt-0">
            <button className="btn btn-light" onClick={onClose}>Cancel</button>
            <button className="btn btn-success px-4" disabled={saving || !selectedSlot}
              onClick={() => onConfirm({ date, time_slot: selectedSlot })}>
              {saving ? <><span className="spinner-border spinner-border-sm me-2" />Saving...</> : <><i className="fa fa-check me-2" />Confirm Session</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// â”€â”€â”€ Client Card â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ClientCard = ({ client, isTrainerPresent, onTick, onCross }) => {
  const alreadyMarked = !!client.today_session_status;
  const markedStatus  = client.today_session_status; // "Delivered" | "No Show" | null
  const canAct = !alreadyMarked && isTrainerPresent && !!client.is_client_present;
  const progress = Math.min(
    100,
    client.total_sessions > 0
      ? Math.round((client.sessions_delivered / client.total_sessions) * 100)
      : 0
  );
  const remaining = Math.max(0, client.sessions_remaining);
  const expiringSoon =
    client.end_date &&
    moment(client.end_date).diff(moment(), "days") <= 7 &&
    moment(client.end_date).diff(moment(), "days") >= 0;
  const disabledReason = alreadyMarked
    ? `Already marked: ${markedStatus}`
    : !isTrainerPresent
    ? "Your attendance not marked for this date"
    : !client.is_client_present
    ? "Client has not checked in"
    : "";

  return (
    <div className="col-12 col-md-6 col-xl-4 mb-3">
      <div
        className={`card h-100 border-0 shadow-sm ${expiringSoon ? "border-warning border" : ""} ${alreadyMarked ? "" : !canAct ? "opacity-75" : ""}`}
        style={{ borderRadius: 14 }}
      >
        <div className="card-body p-3">
          {/* Header with image */}
          <div className="d-flex align-items-center gap-3 mb-3">
            <div style={{ position: "relative", flexShrink: 0 }}>
              <img
                src={client.client_image || AVATAR_FALLBACK}
                alt={client.client_name}
                style={{ width: 56, height: 56, borderRadius: "50%", objectFit: "cover", border: "2px solid #dee2e6" }}
                onError={(e) => { e.target.src = AVATAR_FALLBACK; }}
              />
              <span title={client.is_client_present ? "Checked in" : "Not checked in"}
                style={{ position: "absolute", bottom: 2, right: 2, width: 12, height: 12, borderRadius: "50%",
                  background: client.is_client_present ? "#198754" : "#dc3545", border: "2px solid #fff" }} />
            </div>
            <div className="flex-grow-1 min-w-0">
              <h6 className="fw-bold mb-0 text-truncate">{client.client_name}</h6>
              <small className="text-muted">{client.client_phone}</small>
              <div>
                <span className={`badge me-1 ${client.package_type === "PT" ? "bg-primary" : client.package_type === "SPT" ? "bg-info text-dark" : "bg-secondary"}`} style={{ fontSize: 10 }}>
                  {client.package_type || "PT"}
                </span>
                <small className="text-muted" style={{ fontSize: 11 }}>{client.package_name}</small>
              </div>
            </div>
          </div>

          {/* Stats grid */}
          <div className="row g-2 mb-2">
            {[
              { val: client.total_sessions,    label: "Total",     bg: "#f0f8ff", cls: "text-primary" },
              { val: client.sessions_delivered, label: "Done",     bg: "#f0fff0", cls: "text-success" },
              { val: remaining,                label: "Remaining", bg: "#fff8f0", cls: "text-danger" },
              { val: client.no_show_count,     label: "No Shows",  bg: "#fff0f0", cls: "text-warning" },
              { val: client.cancel_count,      label: "Cancelled", bg: "#f5f5f5", cls: "" },
              { val: client.end_date ? moment(client.end_date).format("DD MMM") : "-", label: "Expires", bg: "#fff0f5", cls: "text-danger", small: true },
            ].map(({ val, label, bg, cls, small }) => (
              <div key={label} className="col-4 text-center">
                <div className="rounded p-1" style={{ background: bg }}>
                  <div className={`fw-bold ${cls}`} style={{ fontSize: small ? 11 : 15 }}>{val}</div>
                  <div style={{ fontSize: 10 }} className="text-muted">{label}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Progress bar */}
          <div className="mb-3">
            <div className="d-flex justify-content-between mb-1">
              <small className="text-muted">Progress</small>
              <small className="text-muted">{progress}%</small>
            </div>
            <div style={{ height: 8, backgroundColor: "#e9ecef", borderRadius: 4, overflow: "hidden" }}>
              <div style={{
                height: "100%",
                width: `${progress}%`,
                minWidth: progress > 0 ? 6 : 0,
                borderRadius: 4,
                background: progress >= 100 ? "#198754" : progress >= 60 ? "#0d6efd" : "#ffc107",
                transition: "width 0.4s ease"
              }} />
            </div>
          </div>

          {/* Disabled reason / already marked */}
          {alreadyMarked ? (
            <div className="text-center py-2 px-2 rounded" style={{
              background: markedStatus === "Delivered" ? "#d1e7dd" : "#f8d7da",
              border: `1px solid ${markedStatus === "Delivered" ? "#a3cfbb" : "#f1aeb5"}`
            }}>
              <div style={{ fontSize: 26 }}>{markedStatus === "Delivered" ? "\u2713" : "\u2717"}</div>
              <div className="fw-bold" style={{ fontSize: 13, color: markedStatus === "Delivered" ? "#0f5132" : "#842029" }}>
                {markedStatus === "Delivered" ? "Session Delivered" : "Marked as No-Show"}
              </div>
              {client.today_time_slot && (
                <div style={{ fontSize: 12, color: "#155724", fontWeight: 600 }}>
                  {"\u23f0"} {client.today_time_slot}
                </div>
              )}
              <div style={{ fontSize: 11, color: "#6c757d" }}>Already recorded for this date</div>
            </div>
          ) : (
            <>
              {!canAct && (
                <div className="alert alert-warning py-1 px-2 mb-2" style={{ fontSize: 11 }}>
                  <i className="fa fa-lock me-1" />{disabledReason}
                </div>
              )}
              {/* Tick / Cross buttons */}
              <div className="d-flex gap-2">
                <button
                  disabled={!canAct}
                  title={canAct ? "Mark as Present" : disabledReason}
                  onClick={() => onTick(client)}
                  style={{ flex: 1, border: "none", borderRadius: 10, padding: "10px 0", cursor: canAct ? "pointer" : "not-allowed",
                    background: canAct ? "#198754" : "#e9ecef", color: canAct ? "#fff" : "#adb5bd",
                    fontWeight: 700, fontSize: 18, lineHeight: 1 }}>
                  {"\u2713"} Present
                </button>
                <button
                  disabled={!canAct}
                  title={canAct ? "Mark as No-Show" : disabledReason}
                  onClick={() => onCross(client)}
                  style={{ flex: 1, border: "none", borderRadius: 10, padding: "10px 0", cursor: canAct ? "pointer" : "not-allowed",
                    background: canAct ? "#dc3545" : "#e9ecef", color: canAct ? "#fff" : "#adb5bd",
                    fontWeight: 700, fontSize: 18, lineHeight: 1 }}>
                  {"\u2717"} No-Show
                </button>
              </div>
            </>
          )}

          {client.last_session_date && (
            <p className="text-muted text-center mt-2 mb-0" style={{ fontSize: 11 }}>
              Last: {moment(client.last_session_date).format("DD MMM YYYY")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
//  Main Component
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
const TrainerPortal = () => {
  const { state } = useContext(NoteState);
  const { branch_id } = state;

  const today = moment().format("YYYY-MM-DD");
  const defaultStart = moment().subtract(1, "month").startOf("month").date(26).format("YYYY-MM-DD");
  const defaultEnd   = moment().startOf("month").date(25).format("YYYY-MM-DD");

  const [periodStart, setPeriodStart]   = useState(defaultStart);
  const [periodEnd, setPeriodEnd]       = useState(defaultEnd);
  const [sessionDate, setSessionDate]   = useState(today);

  const [clients, setClients]           = useState([]);
  const [isTrainerPresent, setIsTrainerPresent] = useState(false);
  const [commission, setCommission]     = useState(null);
  const [sessionStats, setSessionStats] = useState(null);
  const [history, setHistory]           = useState([]);
  const [historyPage, setHistoryPage]   = useState(1);
  const [historyTotal, setHistoryTotal] = useState(0);

  const [loadingClients, setLoadingClients]         = useState(false);
  const [loadingCommission, setLoadingCommission]   = useState(false);
  const [loadingHistory, setLoadingHistory]         = useState(false);
  const [markLoading, setMarkLoading]               = useState(false);
  const [includeExpired, setIncludeExpired]         = useState(false);
  const [searchQuery, setSearchQuery]               = useState("");
  const [activeTab, setActiveTab]                   = useState("clients");

  const [showSlotModal, setShowSlotModal]   = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  // â”€â”€ Fetch clients (with check_date for attendance) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const fetchClients = useCallback(async () => {
    setLoadingClients(true);
    try {
      const res = await UserServices.trainerPortalMyClients(branch_id, includeExpired, sessionDate);
      setClients(res.data?.data || []);
      setIsTrainerPresent(!!res.data?.is_trainer_present);
    } catch {
      setClients([]);
      setIsTrainerPresent(false);
    } finally { setLoadingClients(false); }
  }, [branch_id, includeExpired, sessionDate]);

  const fetchCommission = useCallback(async () => {
    setLoadingCommission(true);
    try {
      const res = await UserServices.trainerPortalMyCommission(branch_id, periodStart, periodEnd);
      setCommission(res.data?.commission || null);
      setSessionStats(res.data?.session_stats || null);
    } catch { setCommission(null); }
    finally { setLoadingCommission(false); }
  }, [branch_id, periodStart, periodEnd]);

  const fetchHistory = useCallback(async () => {
    setLoadingHistory(true);
    try {
      const res = await UserServices.trainerPortalMyHistory({ branch_id, page: historyPage, limit: 20, start_date: periodStart, end_date: periodEnd });
      setHistory(res.data?.data?.data || []);
      setHistoryTotal(res.data?.pagination?.total_record || 0);
    } catch { setHistory([]); }
    finally { setLoadingHistory(false); }
  }, [branch_id, historyPage, periodStart, periodEnd]);

  useEffect(() => { fetchClients(); }, [fetchClients]);
  useEffect(() => { if (activeTab === "commission") fetchCommission(); }, [activeTab, fetchCommission]);
  useEffect(() => { if (activeTab === "history") fetchHistory(); }, [activeTab, fetchHistory]);

  // â”€â”€ Tick â†’ open slot picker â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleTick = (client) => { setSelectedClient(client); setShowSlotModal(true); };

  // â”€â”€ Slot confirmed â†’ POST as Delivered â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleSlotConfirm = async ({ date, time_slot }) => {
    if (!selectedClient) return;
    setMarkLoading(true);
    try {
      await UserServices.trainerPortalMarkAttendance({
        branch_id: selectedClient.branch_id || branch_id,
        client_id: selectedClient.client_id,
        order_id:  selectedClient.order_id,
        package_id: selectedClient.package_id,
        date, time_slot,
        staff_status: "Delivered", client_status: "Delivered",
        type: selectedClient.package_type || "PT",
      });
      Swal.fire({ icon: "success", title: "Session Marked!",
        html: `<b>${selectedClient.client_name}</b> — ${time_slot}<br/>${moment(date).format("DD MMM YYYY")}`,

        timer: 2200, showConfirmButton: false });
      setShowSlotModal(false);
      fetchClients();
      if (activeTab === "commission") fetchCommission();
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to mark session.";
      Swal.fire({ icon: "error", title: "Error", text: typeof msg === "string" ? msg : JSON.stringify(msg) });
    } finally { setMarkLoading(false); }
  };

  // â”€â”€ Cross â†’ No-Show â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleCross = (client) => {
    Swal.fire({
      title: "Mark as No-Show?",
      html: `<b>${client.client_name}</b> â€” ${moment(sessionDate).format("DD MMM YYYY")}`,
      icon: "warning", showCancelButton: true,
      confirmButtonColor: "#dc3545", confirmButtonText: "Yes, No-Show",
    }).then(async (r) => {
      if (!r.isConfirmed) return;
      setMarkLoading(true);
      try {
        await UserServices.trainerPortalMarkAttendance({
          branch_id: client.branch_id || branch_id,
          client_id: client.client_id, order_id: client.order_id, package_id: client.package_id,
          date: sessionDate, staff_status: "Delivered", client_status: "No Show",
          time_slot: null, type: client.package_type || "PT",
        });
        Swal.fire({ icon: "success", title: "No-Show Recorded",
          text: `${client.client_name} marked as No-Show.`, timer: 1800, showConfirmButton: false });
        fetchClients();
        if (activeTab === "commission") fetchCommission();
      } catch (err) {
        const msg = err?.response?.data?.message || "Failed to mark no-show.";
        Swal.fire({ icon: "error", title: "Error", text: typeof msg === "string" ? msg : JSON.stringify(msg) });
      } finally { setMarkLoading(false); }
    });
  };

  const filteredClients = clients.filter(
    (c) => !searchQuery ||
      c.client_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.package_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const pkr = (n) => Number(n || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 });

  return (
    <div className="mt-1 main-inner-pd">
      <div className="site-main-design">
        <MenuButton />

        {/* Header */}
        <div className="card shadow-sm border-0 mb-3" style={{ borderRadius: 14 }}>
          <div className="card-body p-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <h4 className="fw-bold mb-0 text-primary"><i className="fa fa-dumbbell me-2" />Session Tracker</h4>
              <small className="text-muted">Mark attendance &bull; Track sessions &bull; View commission</small>
            </div>
            <div className="d-flex gap-2 align-items-center flex-wrap">
              <div>
                <label className="form-label small mb-0 fw-semibold">From</label>
                <input type="date" className="form-control form-control-sm" value={periodStart} onChange={(e) => setPeriodStart(e.target.value)} />
              </div>
              <div>
                <label className="form-label small mb-0 fw-semibold">To</label>
                <input type="date" className="form-control form-control-sm" value={periodEnd} onChange={(e) => setPeriodEnd(e.target.value)} />
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <ul className="nav nav-tabs mb-3">
          {[{ key: "clients", label: "My Clients", icon: "fa-users" }/*, { key: "commission", label: "Commission", icon: "fa-coins" }, { key: "history", label: "History", icon: "fa-list-alt" }*/].map((t) => (
            <li className="nav-item" key={t.key}>
              <button className={`nav-link ${activeTab === t.key ? "active fw-semibold" : ""}`} onClick={() => setActiveTab(t.key)}>
                <i className={`fa ${t.icon} me-1`} />{t.label}
              </button>
            </li>
          ))}
        </ul>

        {/* â”€â”€ TAB: My Clients â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {activeTab === "clients" && (
          <>
            {/* Trainer attendance banner */}
            {!loadingClients && !isTrainerPresent && (
              <div className="alert alert-warning d-flex align-items-center gap-2 mb-3">
                <i className="fa fa-exclamation-triangle fa-lg" />
                <span><strong>Your attendance is not marked for {moment(sessionDate).format("DD MMM YYYY")}.</strong> Session buttons are disabled. Contact HR if incorrect.</span>
              </div>
            )}
            {!loadingClients && isTrainerPresent && (
              <div className="alert alert-success d-flex align-items-center gap-2 mb-3 py-2">
                <i className="fa fa-check-circle" />
                <span>You are <strong>Present</strong> on {moment(sessionDate).format("DD MMM YYYY")}. Session marking is enabled.</span>
              </div>
            )}

            {/* Controls */}
            <div className="d-flex justify-content-between align-items-end mb-3 flex-wrap gap-2">
              <div className="d-flex gap-2 flex-wrap align-items-end">
                <div className="input-group" style={{ maxWidth: 260 }}>
                  <span className="input-group-text bg-white border-end-0"><i className="fa fa-search text-muted" /></span>
                  <input type="text" className="form-control border-start-0" placeholder="Search client..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                </div>
                <div>
                  <label className="form-label small fw-semibold mb-0">Session Date</label>
                  <input type="date" className="form-control form-control-sm" value={sessionDate} max={today} onChange={(e) => setSessionDate(e.target.value)} />
                </div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <div className="form-check form-switch mb-0">
                  <input className="form-check-input" type="checkbox" id="includeExpired" checked={includeExpired} onChange={(e) => setIncludeExpired(e.target.checked)} />
                  <label className="form-check-label small" htmlFor="includeExpired">Show Expired</label>
                </div>
                <button className="btn btn-outline-secondary btn-sm" onClick={fetchClients}><i className="fa fa-sync me-1" />Refresh</button>
              </div>
            </div>

            {/* Summary pills */}
            {clients.length > 0 && (
              <div className="d-flex gap-2 flex-wrap mb-3">
                <span className="badge bg-primary rounded-pill px-3 py-2">{clients.length} Active Clients</span>
                <span className="badge bg-success rounded-pill px-3 py-2">{clients.reduce((s, c) => s + (c.sessions_delivered || 0), 0)} Done</span>
                <span className="badge bg-warning text-dark rounded-pill px-3 py-2">{clients.reduce((s, c) => s + Math.max(0, c.sessions_remaining || 0), 0)} Remaining</span>
                <span className="badge bg-danger rounded-pill px-3 py-2">{clients.reduce((s, c) => s + (c.no_show_count || 0), 0)} No Shows</span>
                <span className={`badge rounded-pill px-3 py-2 ${clients.filter((c) => c.is_client_present).length > 0 ? "bg-success" : "bg-secondary"}`}>
                  {clients.filter((c) => c.is_client_present).length} Checked In
                </span>
              </div>
            )}

            {loadingClients ? (
              <div className="text-center py-5"><div className="spinner-border text-primary" /><p className="mt-2 text-muted">Loading clients...</p></div>
            ) : filteredClients.length === 0 ? (
              <div className="text-center py-5 text-muted"><i className="fa fa-users fa-3x mb-3 d-block" /><p>{searchQuery ? "No clients match." : "No active clients found."}</p></div>
            ) : (
              <div className="row">
                {filteredClients.map((c) => (
                  <ClientCard key={c.order_id} client={c} isTrainerPresent={isTrainerPresent} onTick={handleTick} onCross={handleCross} />
                ))}
              </div>
            )}
          </>
        )}

        {/* â”€â”€ TAB: Commission â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {activeTab === "commission" && (
          <>
            <div className="d-flex justify-content-end mb-3">
              <button className="btn btn-outline-primary btn-sm" onClick={fetchCommission}><i className="fa fa-sync me-1" />Recalculate</button>
            </div>
            {loadingCommission ? (
              <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
            ) : !commission ? (
              <div className="text-center py-5 text-muted"><i className="fa fa-coins fa-3x mb-3 d-block" /><p>No commission data for this period.</p></div>
            ) : (
              <>
                <div className="row mb-4">
                  <CommissionCard label="Gross Commission" value={`PKR ${pkr(commission.commission)}`} cls="bg-success bg-opacity-10" />
                  <CommissionCard label="PT Commission" value={`PKR ${pkr(commission.pt_commission)}`} cls="bg-primary bg-opacity-10" />
                  <CommissionCard label="SPT Commission" value={`PKR ${pkr(commission.small_pt_commission)}`} cls="bg-info bg-opacity-10" />
                  <CommissionCard label="GX Commission" value={`PKR ${pkr(commission.gx_commission)}`} cls="bg-warning bg-opacity-10" />
                </div>
                {sessionStats && (
                  <div className="row mb-4">
                    <CommissionCard label="Sessions Delivered" value={sessionStats.delivered} />
                    <CommissionCard label="Client No Shows" value={sessionStats.client_no_show} />
                    <CommissionCard label="Trainer No Shows" value={sessionStats.trainer_no_show} />
                    <CommissionCard label="Cancellations" value={sessionStats.cancels} />
                  </div>
                )}
                <div className="alert alert-info py-2 mb-3">
                  <i className="fa fa-info-circle me-2" /><small><strong>Formula: </strong>{commission.formula_guide}</small>
                </div>
                {commission.details?.length > 0 && (
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white fw-semibold">Per-Client Breakdown</div>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0 small">
                        <thead className="table-light">
                          <tr><th>Client</th><th>Package</th><th className="text-center">Sessions</th><th className="text-center">Delivered</th><th className="text-center">No Shows</th><th className="text-center">Payable</th><th className="text-end">Commission</th></tr>
                        </thead>
                        <tbody>
                          {commission.details.map((d, i) => (
                            <tr key={i}>
                              <td className="fw-semibold">{d.client_name}</td>
                              <td><span className="badge bg-primary me-1">{d.package_type}</span>{d.package_name}</td>
                              <td className="text-center">{d.total_sessions_in_package}</td>
                              <td className="text-center text-success fw-bold">{d.delivered_sessions}</td>
                              <td className="text-center text-warning">{d.client_no_show_count}</td>
                              <td className="text-center text-primary fw-bold">{d.payable_sessions}</td>
                              <td className="text-end fw-bold text-success">PKR {pkr(d.commission)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="table-light fw-bold">
                          <tr><td colSpan={6} className="text-end">Total</td><td className="text-end text-success">PKR {pkr(commission.commission)}</td></tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}

        {/* â”€â”€ TAB: History â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {activeTab === "history" && (
          <>
            <div className="d-flex justify-content-end mb-3">
              <button className="btn btn-outline-secondary btn-sm" onClick={fetchHistory}><i className="fa fa-sync me-1" />Refresh</button>
            </div>
            {loadingHistory ? (
              <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
            ) : history.length === 0 ? (
              <div className="text-center py-5 text-muted"><i className="fa fa-list-alt fa-3x mb-3 d-block" /><p>No history for this period.</p></div>
            ) : (
              <div className="card border-0 shadow-sm">
                <div className="table-responsive">
                  <table className="table table-hover align-middle small mb-0">
                    <thead className="table-light">
                      <tr><th>Date</th><th>Client</th><th>Package</th><th>Slot</th><th>Your Status</th><th>Client Status</th><th>Type</th><th className="text-center">âœ“</th></tr>
                    </thead>
                    <tbody>
                      {history.map((h) => (
                        <tr key={h.id}>
                          <td><span className="fw-semibold">{moment(h.date).format("DD MMM YYYY")}</span><br /><small className="text-muted">{h.day}</small></td>
                          <td className="fw-semibold">{h.client_name}</td>
                          <td className="text-muted">{h.package_name}</td>
                          <td>{h.time_slot ? <span className="badge bg-info text-dark">{h.time_slot}</span> : <span className="text-muted">â€”</span>}</td>
                          <td>{statusBadge(h.staff_status)}</td>
                          <td>{statusBadge(h.client_status)}</td>
                          <td><span className="badge bg-outline-primary border text-primary">{h.type}</span></td>
                          <td className="text-center">{h.validate_status === "1" ? <i className="fa fa-check-circle text-success" /> : <i className="fa fa-clock text-warning" />}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {historyTotal > 20 && (
                  <div className="card-footer d-flex justify-content-between align-items-center">
                    <small className="text-muted">Showing {history.length} of {historyTotal}</small>
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-secondary btn-sm" disabled={historyPage <= 1} onClick={() => setHistoryPage((p) => p - 1)}>Prev</button>
                      <button className="btn btn-outline-secondary btn-sm" disabled={history.length < 20} onClick={() => setHistoryPage((p) => p + 1)}>Next</button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {/* Slot Picker Modal */}
        {showSlotModal && selectedClient && (
          <SlotPickerModal
            client={selectedClient}
            sessionDate={sessionDate}
            onClose={() => setShowSlotModal(false)}
            onConfirm={handleSlotConfirm}
            saving={markLoading}
          />
        )}
      </div>
    </div>
  );
};

export default TrainerPortal;

